<template>
  <div class='search-popover-common'>
    <el-popover v-bind="{ placement: 'bottom-start', trigger: 'click', width: 'auto', ...popoverAttrs }">
      <template slot="reference">
        <slot name="reference">
          <el-button icon="el-icon-more" />
        </slot>
      </template>
      <slot name="title">
        <div v-if="title"> {{ title }}</div>
      </slot>
      <el-form size="small" v-bind="formAttrs">
        <el-form-item :label="item.label" :key="item.key" v-for="item in config" v-bind="{ ...item }"
          :label-width="item.labelWidth ? item.labelWidth : undefined">
          <!-- 选择框 -->

          <el-select v-if="item.type === 'select'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }">
            <el-option v-for="o in selectAttrs[item.key]" :key="item.optionAttrs && o[item.optionAttrs.key]"
              :label="typeof item.optionAttrs.label === 'function' ? item.optionAttrs.label(o) : o[item.optionAttrs.label]"
              :value="typeof item.optionAttrs.value === 'function' ? item.optionAttrs.value(o) : o[item.optionAttrs.value]" />
          </el-select>
          <!-- 单选框 -->
          <el-radio-group v-if="item.type === 'radio'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }">
            <el-radio v-for="o in selectAttrs[item.key]" :key="item.optionAttrs && o[item.optionAttrs.key]"
              :label="typeof item.optionAttrs.value === 'function' ? item.optionAttrs.value(o) : o[item.optionAttrs.value]">
              {{ typeof item.optionAttrs.label === 'function' ? item.optionAttrs.label(o) : o[item.optionAttrs.label] }}
            </el-radio>
          </el-radio-group>
          <!-- 多选框 -->
          <el-checkbox-group v-if="item.type === 'checkbox'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }">
            <el-checkbox v-for="o in selectAttrs[item.key]" :key="item.optionAttrs && o[item.optionAttrs.key]"
              :label="typeof item.optionAttrs.value === 'function' ? item.optionAttrs.value(o) : o[item.optionAttrs.value]">
              {{ typeof item.optionAttrs.label === 'function' ? item.optionAttrs.label(o) : o[item.optionAttrs.label] }}
            </el-checkbox>
          </el-checkbox-group>
          <!-- 输入框 -->
          <el-input v-if="item.type === 'input'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }" />
          <!-- 计数器 -->
          <el-input-number v-if="item.type === 'inputNumber'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }" />
          <!-- 时间范围选择 -->
          <el-date-picker class="zszj-date-picker" v-if="item.type === 'daterange'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }" @focus="focusDate($event, item.key)" @blur="blurDate($event, item.key)" />
          <!-- 多级联动 -->
          <el-cascader v-if="item.type === 'cascader'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs.style : { width: '150px' }" />
          <!-- 开关 -->
          <el-switch v-if="item.type === 'switch'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs && item.attrs.style : {}" />
          <!-- 滑块 -->
          <el-slider v-if="item.type === 'slider'" v-model="query[item.key]" v-bind="{ ...item.attrs }"
            :style="item.attrs && item.attrs.style ? item.attrs && item.attrs.style : {}" />
          <!-- 插槽 在现有查询组件不满足需求时使用 -->
          <slot :name="item.key" v-if="item.type === 'slot'" />
          <!-- todo 后续可以新增不同类型的组件 -->
        </el-form-item>
        <el-form-item class="operation-button-box" v-if="isCancelShow">
          <slot name="operation">
            <!-- <el-button type="primary" @click="onSearch">查询</el-button> -->
            <el-button type="default" @click="onCancel">清空</el-button>
          </slot>
        </el-form-item>
      </el-form>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    popoverAttrs: {
      type: Object,
      default: () => ({})
    },
    formAttrs: {
      type: Object,
      default: () => ({})
    },
    query: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Array,
      default: () => []
    },
    selectAttrs: {
      type: Object,
      default: () => ({})
    },
    isCancelShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      datePickerDom: null,
      currentKey: ''
    }
  },
  methods: {
    onCancel () {
      this.$emit('update:query', {})
      this.$emit('onCancel')
    },
    blurDate(e, key) {
      console.log("输入生日////////")
      this.datePickerDom.removeEventListener('input', this.dateInput)
    },
    focusDate(e, key) {
      this.currentKey = key
      this.datePickerDom = document.querySelector('.zszj-date-picker .el-input__inner')
      this.datePickerDom.addEventListener('input', this.dateInput)
    },
    dateInput(v) {
      v.stopPropagation()

      let res = v.target.value.replace(/-/g, '')
      if (res.length == 8) {
        let arr = [
          res.slice(0, 4),
          res.slice(4, 6),
          res.slice(6, 8)
        ]
        let time = arr.join('-')
        this.$set(this.query, this.currentKey, time)
      }
    }
  },
  mounted () {
    console.log(this.popoverAttrs);
  }
}
</script>

<style lang="scss" scoped>
// .search-popoer-common {


// }
</style>
